module.exports = __webpack_public_path__ + "img/analysis.98c58404.png";